import React from 'react';

const Toasten = ({ type, message, handleToastClose }) => {
    /* STATUS: 'success' | info | warning  */

    /* I still have some works to do on this component */
    if (message) {
        setTimeout(() => {
            handleToastClose();
        }, 3000);
    }
    return (
        <div className="">
            <div
                className={`${type === '' ? 'oi-toast--switch' : ''} oi-toast`}
                style={{ display: message ? '' : 'none' }}>
                <div>
                    <div className={`status-icon status-icon__${type}`} />
                </div>
                <div className={`oi-toast__divider oi-toast__divider-${type}`}></div>
                <div>
                    <div className="oi-toast__header">{type}</div>
                    <p className="oi-toast__msg">{message ? message : null}</p>
                </div>
                <button className="oi-toast__btn" onClick={handleToastClose}>
                    ✖
                </button>
            </div>
        </div>
    );
};

export default Toasten;
